// @flow
import React from 'react';
import {connect} from 'react-redux';
import Grid from '@material-ui/core/Grid';
import {POSITION_UNDER_FIRST_NEWS} from 'app/constants/ads';
import {MainLayout as Layout} from 'app/layouts/MainLayout';
import HomeNews from 'app/components/HomeNews';
import AdsBox from 'app/components/AdsBox';
import WidgetLastComments from 'app/components/WidgetLastComments';
import FeaturedNews from 'app/components/FeaturedNews';
import FeaturedVideos from 'app/components/FeaturedVideos';

class Home extends React.Component<Props> {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		return (
			<Layout>
				<FeaturedNews />
				<FeaturedVideos />
				<Grid container spacing={16}>
					<Grid item sm={12} md={8} >
						<AdsBox position={POSITION_UNDER_FIRST_NEWS} />
						<HomeNews />
					</Grid>
					<Grid item sm={12} md={4} >
						<WidgetLastComments />
					</Grid>
				</Grid>
			</Layout>
		);
	}
}

const mapStateToProps = (state) => ({
  ads: state.ads
});

const Component = connect(mapStateToProps)(Home);
export {Component as Home}

export default Component;